import React, { Component } from 'react';
import ABSProgressBarLine from '../../../../../components/ABSProgressBarLine';
import ABSLink from '../../../../../components/ABSLink';
import RouteConfig from '../../../../../abs/config/routeConfig';
export interface IABSHotRecommendItemProps {
  name: string;
  percert: number;
  recommendType: string;
  toId: string;
  isHot?: boolean;
}

class HotRecommendItem extends Component<IABSHotRecommendItemProps> {
  renderHot = () => {
    const { isHot } = this.props;
    if (!isHot) { return null; }
    return (
      <div className="abs-home-menu-item-hot">hot</div>
    );
  };
  renderLinkTo = (recommendType: string, toId: string) => {
    if (recommendType === '资产') {
      return `${RouteConfig.productList}?filter_query_list[0][key]=5&filter_query_list[0][value][0]=${toId}`;
    } else {
      return `${RouteConfig.productDealInfo + toId}`;
    }
  }

  render() { 
    const { name, percert, recommendType, toId } = this.props;

    return (
      <div className="hot-recommend-list-item">
        <div className="hot-recommend-list-item-name">
          <ABSLink target="_blank" to={this.renderLinkTo(recommendType, toId)}>{name}</ABSLink>
          {this.renderHot()}
        </div>
        <div className="hot-recommend-list-item-percert">
          <ABSProgressBarLine percent={percert} width={120} displayType="line-single" />
        </div>
      </div>
    );
  }
}

export default HotRecommendItem; 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/right/hotRecommendItem.tsx